import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";

import Layout from "@/components/Layout";
import ComingSoonGate from "@/components/ComingSoonGate";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Shop from "@/pages/Shop";
import CustomStudio from "@/pages/CustomStudio";
import Contact from "@/pages/Contact";
import Account from "@/pages/Account";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <ComingSoonGate>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
              <Routes>
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/shop/studio" element={<CustomStudio />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/payment/success" element={<PaymentSuccess />} />
                  <Route path="/payment/cancel" element={<PaymentCancel />} />
                  <Route path="/admin" element={<AdminLogin />} />
                  <Route path="/admin/dashboard/*" element={<AdminDashboard />} />
                </Route>
              </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
          </CartProvider>
        </AuthProvider>
      </ComingSoonGate>
    </div>
  );
}

export default App;
